import { CommonLaboratoryDatasource } from '@/shared/resources/datasources/common/common-laboratory-datasource'
import {
    BillingSearcherMode,
    BillingSearcherParams
} from '@/modules/billing-module/components/searcher/billing-searcher.model'
import { StrictNullable } from '@/shared/types/app.types'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

export abstract class BillingGridDatasource<R> extends CommonLaboratoryDatasource<R> {
    public abstract getSearcherModes(): BillingSearcherMode[]
    public abstract searcher(searcherParams: BillingSearcherParams): Promise<StrictNullable<IResponseAgGrid<R>>>
}
